import React, { Component } from "react";
import axios from "axios";
import { saveAs } from "file-saver";
import LoadingSpinner from "../components/LoadingSpinner";
import "../App.css";
import "../components/Datasheet.css";

// defining the product variable with details
let productData = {
  product_id: 0,
  product_name: "",
  product_type: "",
  product_sku: "",
  product_price: "",
  short_description: "",
  long_description: "",
  info_description: "",
  tech_specs: "",
  defaultImage: [],
  images: [],
  thumbnails: "",
  datasheet_benefits: "",
  datasheet_features: "",
  device_compatibility: "",
  package_content: "",
  material: "",
  warranty: "",
  certifications: "",
  rating: "",
  upc_code: "",
  unit_height: "",
  unit_width: "",
  unit_depth: "",
  unit_weight: "",
  height: {},
  width: {},
  depth: {},
  weight: {},
  contact_name: "The Joy Factory",
  contact_dep: "Sales Team",
  contact_phone: "949.382.1552",
  contact_email: "sales@thejoyfactory.com",
  footer_company: "The Joy Factory Inc.",
  footer_address: "16811 Hale Ave Bldg D, Irvine, CA 92606",
  footer_email: "sales@thejoyfactory.com",
  footer_phone: "949.216.8869",
  footer_fax: "949.216.8869",
  footer_site: "www.thejoyfactory.com",
};

class App extends Component {
  //  initializes state and processes URL query parameters.
  constructor(props) {
    super(props);
   // List of encouraging messages
    this.messages = [
      "Gathering product details...",
      "Sharpening the layout pixels...",
      "Formatting images for high quality...",
      "Finalizing the PDF structure...",
      "Almost there! Thank you for your patience.",
      "Just a few more seconds..."
    ];
    const query = new URLSearchParams(this.props.location.search);
    this.state = {
      id: query.get("id"),
      sku: query.get("sku"),
      loading: false,
      loadingMessage: this.messages[0] // Set initial message
    };
  }

  // Use Componenet state data to handle PDF Download
  createAndDownloadPdf = () => {
    axios
      .post("/create-pdf", this.state)
      .then(() => axios.get("fetch-pdf", { responseType: "blob" }))
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        saveAs(pdfBlob, "datasheet-tjf.pdf");
      });
  };

  // Currently being used to handle PDF Download
 // Optimized PDF Download with Async/Await to prevent race conditions
 downloadPdf = async () => {
    // 1. Start loading state and the encouragement timer
    this.setState({ loading: true, loadingMessage: this.messages[0] });

    let messageIndex = 0;
    this.messageInterval = setInterval(() => {
      messageIndex++;
      if (messageIndex < this.messages.length) {
        this.setState({ loadingMessage: this.messages[messageIndex] });
      }
    }, 3500);

    try {
      console.log("Requesting PDF generation on server...");

      // 2. ONE-STEP DOWNLOAD
      // We send the data and tell axios to expect a 'blob' (the file itself) back
      const response = await axios.post("/download-pdf", productData, { 
        responseType: "blob" 
      });

      console.log("PDF received from server. Saving...");

      // 3. Create the file from the response data
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      saveAs(pdfBlob, `datasheet-${productData.product_sku}.pdf`);

    } catch (error) {
      console.error("PDF Download Error:", error);
      alert("There was an error generating your PDF. Please try again.");
    } finally {
      // 4. CLEANUP
      clearInterval(this.messageInterval);
      this.setState({ loading: false });
    }
  };

  fetchData = () => {
    const pageUrl = new URL(window.location);
    const searchParams = pageUrl.searchParams;
    /*
        Utility functions for rendering
    */
    // Function to strip HTML from product descriptions, leaving just the text
    function stripHtml(html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      return doc.body.textContent || "";
    }

    // Function to strip link tags from product descriptions
    function stripLinks(desc) {
      let cleanDesc = "";
      let regexValid = false;
      try {
        // Check if there are links in the Tech Specs Description
        new RegExp(/<a.*?>[^<]*<\/a>/);
        regexValid = true;
      } catch (e) {
        regexValid = false;
      }
      // If a link is found, also remove the double BR tags
      if (regexValid) {
        let removedFirstBR = desc.replace(/<br><br>/, "");
        cleanDesc = removedFirstBR.replace(/<a.*?>[^<]*<\/a>/g, "");
        return cleanDesc;
      } else {
        return desc;
      }
    }

    // find product types from the field data
    function findProductType(fields) {
      fields.forEach((field) => {
        if (field.node.name === "product_type") {
          productData.product_type = field.node.value;
        }
      });
    }

    // find device compatibility from field node
    function findDeviceCompatibility(fields) {
      fields.forEach((field) => {
        if (field.node.name === "device_compatibility") {
          let device_compatibility = field.node.value;
          productData.device_compatibility = device_compatibility.replace(
            ",",
            ","
          );
        }
      });
    }

    // find certification details
    function findCertifications(fields) {
      fields.forEach((field) => {
        if (field.node.name === "certifications") {
          let certifications = field.node.value;
          productData.certifications = certifications.replace(",", ",");
        }
      });
    }

    // find rating details
    function findRating(fields) {
      fields.forEach((field) => {
        if (field.node.name === "rating") {
          let rating = field.node.value;
          productData.rating = rating.replace(",", " | ");
        }
      });
    }

    // find package content details
    function findPackageContent(fields) {
      let packageContent = ""; // Default to empty string

      // Loop through fields to find the package_content value
      fields.forEach((field) => {
        if (field.node.name === "package_content" && field.node.value) {
          packageContent = field.node.value;
        }
      });

      // Only set productData.package_content if we found the value
      if (packageContent) {
        productData.package_content = packageContent;
      } else {
        productData.package_content = ""; // Set to empty string if not found
      }
    }

    // find material details from custom fields array
    function findMaterial(fields) {
      fields.forEach((field) => {
        if (field.node.name === "material") {
          productData.material = field.node.value;
        }
      });
    }

    // spit product description and get separate product details
    function splitProductDescription(desc) {
      // Default to an empty array if split doesn't return the expected number of parts
      var array = desc.split("&lt;!-- split --&gt;");
      // Ensure the array has the expected number of parts
      productData.short_description = array[0] ? stripHtml(array[0]) : "";
      productData.long_description = array[1] ? array[1] : "";
      productData.info_description = array[2] ? array[2] : "";
      productData.tech_specs = array[3] ? stripLinks(array[3]) : "";
    }

    // get thumbnail Images
    function generateThumbnails(images) {
      let thumbnails = "";

      // Ensure images is an array and not empty
      if (Array.isArray(images) && images.length > 0) {
        images.forEach((image, index) => {
          // Only add images if img320px exists and index is not 0, and is less than 4
          if (index !== 0 && index < 4 && image.node && image.node.img320px) {
            thumbnails += `<img class="thumbnail" src="${image.node.img320px}" alt="Thumbnail ${index}">`;
          }
        });
      }

      // If thumbnails were generated, add them to productData
      if (thumbnails) {
        productData.thumbnails = thumbnails;
      }
    }

    // find benefits details
    function findBenefits(fields) {
      let benefits = ""; // Default to an empty string if not found

      // Find the 'datasheet_benefits' value from fields
      fields.forEach((field) => {
        if (field.node.name === "datasheet_benefits" && field.node.value) {
          benefits = field.node.value;
        }
      });

      // If no benefits were found, exit early
      if (!benefits) {
        console.error("No benefits found.");
        return; // Prevent further processing if benefits are missing
      }

      // Split the benefits string into an array
      let array = benefits.split(",");

      // Ensure that productData.datasheet_benefits is initialized
      if (!productData.datasheet_benefits) {
        productData.datasheet_benefits = "";
      }

      // Build the table rows for the benefits
      array.forEach((item, index) => {
        if (index % 3 === 0) {
          productData.datasheet_benefits += `<tr>`;
        }
        productData.datasheet_benefits += `<td><li>${item}</li></td>`;
        if (index === 2 || index === 5) {
          productData.datasheet_benefits += `</tr>`;
        }
      });
    }

    // find feature details from the product
    function findFeatures(fields) {
      let features = ""; // Default to empty string
      let productLine = ""; // Default to empty string
      let axtionSeries = ""; // Default to empty string

      // Loop through fields to extract values
      fields.forEach((field) => {
        if (field.node.name === "datasheet_features" && field.node.value) {
          features = field.node.value;
        }
        if (field.node.name === "product_line" && field.node.value) {
          productLine = field.node.value;
        }
        if (field.node.name === "axtion_series" && field.node.value) {
          axtionSeries = field.node.value;
        }
      });

      // Check if the required value is available
      if (!features) {
        console.error("No features found.");
        return; // Prevent further processing if features are missing
      }

      let featureList = features.split(",");
      let icons = findFeatureIcons(featureList, productLine, axtionSeries);

      // Ensure icons length matches featureList length to avoid index mismatch
      if (icons.length !== featureList.length) {
        console.error("Mismatch between feature list and icon list.");
        return;
      }

      // Add features to datasheet, ensuring table structure is correct
      featureList.forEach((item, index) => {
        if (index % 3 === 0) {
          productData.datasheet_features += `<tr>`;
        }
        productData.datasheet_features += `<td><li class="feature-item"><img class="feature-icon" src="${icons[index]}" alt="${item}">${item}</li></td>`;
        if (index === 2 || index === 5) {
          productData.datasheet_features += `</tr>`;
        }
      });
    }

    // find feature icons from the from the given details
    function findFeatureIcons(features, productLine, axtionSeries) {
      let domain = "https://shop.thejoyfactory.com/content/datasheet/icons/";
      let iconsrc = [];

      // Check if features array is not empty
      if (!Array.isArray(features) || features.length === 0) {
        console.warn("No features provided for icon generation.");
        return iconsrc; // Return empty array if no features are provided
      }

      // Validate productLine before usage
      if (!productLine) {
        console.error("Product line is missing.");
        return iconsrc; // Return empty array if productLine is missing
      }

      // Loop through each feature and generate the corresponding icon URL
      features.forEach((item) => {
        let spaceToDash = item.replace(/ /g, "-"); // Replace spaces with dashes
        let icon = "";

        // If axtionSeries is provided, include it in the icon URL
        if (axtionSeries) {
          icon = `${domain}${productLine}-${axtionSeries}-${spaceToDash}.png`;
        } else {
          icon = `${domain}${productLine}-${spaceToDash}.png`;
        }

        // Normalize the URL to lowercase
        let url = icon.toLowerCase();
        iconsrc.push(url);
      });

      return iconsrc;
    }

    // get UPC code from the field node
    function getUpcCode(fields) {
      fields.forEach((field) => {
        if (field.node.name === "upc_code") {
          productData.upc_code = field.node.value;
        }
      });
    }

    // get unit dimensions details
    function getUnitDimensions(fields) {
      fields.forEach((field) => {
        // Get unit height
        if (field.node.name === "unit_height") {
          productData.unit_height = field.node.value;
        }
        // Get unit width
        else if (field.node.name === "unit_width") {
          productData.unit_width = field.node.value;
        }
        // Get unit depth
        else if (field.node.name === "unit_depth") {
          productData.unit_depth = field.node.value;
        }
        // Get unit weight
        else if (field.node.name === "unit_weight") {
          productData.unit_weight = field.node.value;
        }
      });
    }

    // Assign data values into state
    function handleData(data) {
      const product = data?.data?.site?.product;
      productData.product_id = product.entityId;
      productData.product_name = product.name;
      findProductType(product.customFields.edges);
      getUpcCode(product.customFields.edges);
      getUnitDimensions(product.customFields.edges);
      findCertifications(product.customFields.edges);
      findRating(product.customFields.edges);
      productData.product_sku = product.sku;
      productData.product_price = product.prices.price.value;
      splitProductDescription(product.description);
      productData.defaultImage = product.defaultImage;
      productData.images = product.images.edges;
      generateThumbnails(product.images.edges);
      findBenefits(product.customFields.edges);
      findFeatures(product.customFields.edges);
      productData.warranty = product.warranty;
      productData.depth = product.depth;
      productData.height = product.height;
      productData.weight = product.weight;
      productData.width = product.width;
      findPackageContent(product.customFields.edges);
      findMaterial(product.customFields.edges);
      findDeviceCompatibility(product.customFields.edges);
    }

    /*
        Page rendering logic
    */
    function renderPage(data) {
      // Render the HTML for the product
      const product = data.data.site.product;

      handleData(data);

      document.getElementById("product").innerHTML = renderProduct(productData);
    }

    // function to show the data in the US version in datasheet view
    function renderProduct(product) {
      // Footer
      const footer = `
          <table class="footer text-left">
            <tr>
                <td style="width:73%;">
                  <table>
                  <tr>
                    <td class="footer-company" style="width:73%;">The Joy Factory Inc.</td>
                  </tr>
                  <tr>
                    <td class="footer-second-desc">${product.footer_address} <span style="color: #d0103a;">|</span> ${product.footer_email} <span style="color: #d0103a;">|</span> T : ${product.footer_phone} <span style="color: #d0103a;">|</span> F : ${product.footer_fax} <span style="color: #d0103a;">|</span> ${product.footer_site}</td>
                  </tr>
                  </table>     
                </td>
                <td style="width:16.5%;">
                  <table class="footer-icons" style="width:100%;">
                    <tr>
                      <td class="footer-image"><img src="https://shop.thejoyfactory.com/content/datasheet/protect.jpg" alt="The Joy Factory Protect Icon"></td>
                      <td class="footer-image"><img src="https://shop.thejoyfactory.com/content/datasheet/secure.jpg" alt="The Joy Factory Secure Icon"></td>
                      <td class="footer-image"><img src="https://shop.thejoyfactory.com/content/datasheet/position.jpg" alt="The Joy Factory Position Icon"></td>
                    </tr>
                    <tr>
                      <td class="footer-image-content">Protect</td>
                      <td class="footer-image-content">Secure</td>
                      <td class="footer-image-content">Position</td>
                    </tr>
                  </table>
                </td>
                <td align="center" style="width:10.5%;">
                  <img src="https://shop.thejoyfactory.com/content/datasheet/logo-main-240.png" alt="The Joy Factory logo." style="width:100px;">
                </td>
            </tr>
          </table>
          `;

      // Contact Section - currently not used on customer preview
      const contact = `
          <div class="contact-table" style="margin: 10px 0 300px 0; padding: 10px;">
            <table class="contact" style="background: white; width: 100%;">
              <tr>
                <td class="text-center" style="padding: 5px 30px; width: 25%;">
                  <img src="https://shop.thejoyfactory.com/content/datasheet/logo-lg.png" alt="The Joy Factory logo." style="width:100px;">
                </td>
                <td class="text-left" style="padding: 5px 30px; width: 25%;">
                  <p style="font-size: 1.25rem; font-weight: bold;">${product.contact_name}</p>
                  <p style="font-size: 0.9rem; font-weight: bold;">${product.contact_dep}</p>
                </td>
                <td class="text-left" style="border-left:solid 2px red; padding: 5px 30px; width: 50%;">
                  <p>Direct Phone Number | ${product.contact_phone}</p>
                  <p>Email Address | ${product.contact_email}</p>
                </td>
              </tr>
            </table>
          </div>
        `;

      // Render the product into a preview
      return `
          <!-- Start: Page One -->
          <div class="page" id="page-one">
            <table class="text-left">
              <tr>
                <td class="product-header">
                  <h1 class="product-name">${product.product_name}</h1>
                  <p class="product-short-desc">${product.short_description}</p>
                  <hr class="hr-short hr-left">
                  <div class="product-sku-price">
                    <p class="product-sku">SKU: ${product.product_sku}</p>
                    <p class="product-price">MSRP: $${product.product_price}</p>
                  </div>
                </td>
              </tr>
            </table>
            <table class="product-desc-container">
              <tr>
                <td class="product-description">
                  ${product.long_description}
                  ${product.info_description}
                </td>
                <td class="product-images">
                  ${
                    product.defaultImage
                      ? `<img class="default-image" src="${product.defaultImage.img320px}" alt="The Joy Factory product image">`
                      : ""
                  }
                  <p>
                    ${product.thumbnails}
                  </p>
                </td>
              </tr>
            </table>
            <div class="benefits">
               <span class="benefits-header">Benefits</span>
               <br>
               <table>
                  ${product.datasheet_benefits}
               </table>
            </div>
            <div class="features">
               <span class="features-header-main">Features</span>
               <br>
               <table>
                  ${product.datasheet_features}
               </table>
            </div>
            ${footer}
          </div>
          <!-- End: Page One -->

          <!-- Start: Page Two -->
          <div class="page" id="page-two">
            <div class="tech-specs-header">
              <p>
                Technical Specifications
                <br>
                <span class="underline"></span>
              </p>
            </div>
            <table class="tech-specs-container">
              <tr>
                <td class="tech-specs-image-container" style="padding: 0 25px;">
                  ${
                    product.images[product.images.length - 1]
                      ? `<img class="tech-spec-image" src="${
                          product.images[product.images.length - 1].node
                            .img320px
                        }" alt="The Joy Factory product image">`
                      : ""
                  }
                  <p class="disclaimer" style="font-size: 7px;">The information on this data sheet is subject to change at any time at the discretion of The Joy Factory</p>
                </td>
                <td class="tech-specs">
                  ${product.tech_specs}
                </td>
              </tr>
            </table>
            <div class="product-specifications">
              <table class="product-specs-table">
                <tr>
                  <td class="product-info-container">
                    <div class="product-name text-left">
                      ${product.product_name}
                    </div>
                    <table class="product-info-inner-table">
                      <tr>
                        <div class="product-info-group">
                          <p>SKU: ${product.product_sku}</p>
                          <p>Product type: ${product.product_type}</p>
                          <p>MSRP: $${product.product_price}</p>
                        </div>
                      </tr>
                    </table>
                  </td>
                  <td class="product-specs-container">
                    <table class="product-specs-inner-table">
                      <th class="product-specs-title">Product Specifications</th>
                      <tr>
                        <td>Compatible with: ${
                          product.device_compatibility
                        }</td>
                      </tr>
                      <tr>
                        <td>Product height: ${product.unit_height} in</td>
                      </tr>
                      <tr>
                        <td>Product width: ${product.unit_width} in</td>
                      </tr>
                      <tr>
                        <td>Product thickness: ${product.unit_depth} in</td>
                      </tr>
                      <tr>
                        <td>Product weight: ${product.unit_weight} lb</td>
                      </tr>
                      <tr>
                        <td>Package height: ${product.height.value} ${
        product.height.unit
      }</td>
                      </tr>
                      <tr>
                        <td>Package width: ${product.width.value} ${
        product.width.unit
      }</td>
                      </tr>
                      <tr>
                        <td>Package depth: ${product.depth.value} ${
        product.depth.unit
      }</td>
                      </tr>
                      <tr>
                        <td>Package weight: ${product.weight.value} ${
        product.weight.unit
      }</td>
                      </tr>
                      <tr>
                        <td>UPC: ${product.upc_code}</td>
                      </tr>
                      <tr>
                        <td>Warranty: ${product.warranty}</td>
                      </tr>
                      <tr>
                        <td>Certifications: ${product.certifications}</td>
                      </tr>
                      <tr>
                        <td>Rating: ${product.rating}</td>
                      </tr>
                      <tr>
                        <td>Package content: ${product.package_content}</td>
                      </tr>
                      <tr>
                        <td>Material: ${product.material || 'N/A'}</td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </div>
            ${footer}
          </div>
          <!-- End: Page Two -->
        `;
    }

    function renderPrice(prices) {
      // Render the price component from the supplied prices
      return `<span></span>`;
    }

    // Check for required parameters, throw an error if they're not found
    if (!this.state) {
      throw new Error(
        "At least one of the required URL parameters (Store URL, Token) was not supplied or was invalid"
      );
    } else {
      // get product from the api by passing id and sku of the product
      axios
        .get(`/get-product?id=${this.state.id}&sku=${this.state.sku}`)
        .then((data) => {
          // With our data loaded, render the product listing
          renderPage(data.data);
        })
        .catch((e) => {
          // Some error was encountered
          throw e;
        });
    }
  };

  // fetch data on the page load
  componentDidMount = () => {
    this.fetchData();
  };

  // render data in the browser
  render() {
    const { loading, loadingMessage } = this.state; // Destructure for cleaner code
    
    return (
      <div className="App container my-5">
        {/* Full Screen Loading Overlay */}
        {loading && (
          <div className="loading-overlay">
            <div className="loading-card shadow-lg">
              <LoadingSpinner />
              <h3 className="mt-4 fw-bold">{loadingMessage}</h3>
              <p className="text-muted">Hand-crafting your datasheet...</p>
              <small className="text-secondary">Thank you for your patience!</small>
            </div>
          </div>
        )}

        <div className="LoadingSpinner-wrapper">
          <img
            className="download-icon"
            src="https://shop.thejoyfactory.com/content/datasheet/icons/data-sheet-icon-01.png"
            alt="icon"
          />
          {/* We disable the button while loading to prevent server overload */}
          <button 
            className="btn btn-primary" 
            onClick={this.downloadPdf}
            disabled={loading} 
          >
            {loading ? "Processing..." : "Download PDF"}
          </button>
        </div>
        
        <div className="py-5" id="intro">
          <h1>Datasheet Preview</h1>
        </div>
        <div id="product"></div>
      </div>
    );
  }
}

export default App;
